import { render, staticRenderFns } from "./UploadKeysTags.vue?vue&type=template&id=2863a36e&"
import script from "./UploadKeysTags.vue?vue&type=script&lang=ts&"
export * from "./UploadKeysTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports